import { Component, OnInit, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VisaSubClass, OHSCProvider, LookupData, BridgingVisas, Tab_Title } from 'src/app/shared/models/lookup-data.model';
import { ActivatedRoute, Router } from '@angular/router';
import { VisaOshc } from '../models/visa-ohsc';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { DateTime } from 'luxon';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { Observable } from 'rxjs';
import { ModalService } from 'src/app/shared/services/modal.service';
import { compareVisaOHSCDetails } from '../shared/utils/ModelUtils';
import { slideInOut } from '../animations/slideInOut';
import { FormService } from 'src/app/shared/services/form.service';
import { Title } from '@angular/platform-browser';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'online-app-visa-ohsc',
  templateUrl: './visa-ohsc.component.html',
  styleUrls: ['./visa-ohsc.component.css'],
  host: {
    class: 'application-section-component'
  },
  animations: [slideInOut]
})
export class VisaOhscComponent implements OnInit, AfterContentChecked {

  visaohscFormGroup: FormGroup;
  isFormSubmitted = false;
  visaSubClasses: VisaSubClass[] = [];
  ohscProviders: OHSCProvider[] = [];
  isOnshoreWhileLodgingVisa: boolean;
  holdsAustralianVisa: boolean;
  isBridgingVisa: boolean;
  hasOshc: boolean;
  applicationId: number;
  visaExpiryDate: string;
  initialVisaOHSCDetails: VisaOshc;
  isHealthCoverFromDEInternational: boolean;
  bridgingVisas: LookupData[] = BridgingVisas;

  isSubmittedApplication = false;
  isSaveSuccessful = false;
  isScrollDone = false;
  showChangeImpactModal: boolean = false;
  isReciprocalHealthCareCountry: boolean = false;

  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'IsOnshoreWhileLodgingVisa', formFieldName: 'isOnshoreWhileLodgingVisa', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HoldsAustralianVisa', formFieldName: 'holdsAustralianVisa', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'VisaSubclassId', formFieldName: 'visaSubclassId', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'VisaSubclassCode', formFieldName: 'visaSubclassId', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'VisaExpiryDate', formFieldName: 'visaExpiryDate', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'VisaNumber', formFieldName: 'visaNumber', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HasOshc', formFieldName: 'hasOshc', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'OshcProviderCode', formFieldName: 'oshcProviderCode', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'OshcExpiryDate', formFieldName: 'oshcExpiryDate', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IsHealthCoverFromDEInternational', formFieldName: 'isHealthCoverFromDEInternational', apiValidationErrorMsg: null }
  ];

  @ViewChild('resolve') resolve: ElementRef;
  constructor(private formBuilder: FormBuilder,
    private store: Store<any>,
    private router: Router,
    private modalService: ModalService,
    private formService: FormService,
    private applicationService: ApplicationService,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilityService,
    private titleService: Title) {

    // this.configureJquery();

    this.activatedRoute.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });

  }

  getDateInString(dateObject: Date): string {
    if (!dateObject || !dateObject.getMonth || !dateObject.getFullYear)
      return '';
      
    return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
  }

  setVisaExpiryDate(dateObject: Date) {
    this.visaohscFormGroup.patchValue({
      visaExpiryDate: dateObject,
    });
    this.visaohscFormGroup.updateValueAndValidity();
  }

  setOhscExpiryDate(dateObject: Date) {
    this.visaohscFormGroup.patchValue({
      oshcExpiryDate: dateObject,
    });
    this.visaohscFormGroup.updateValueAndValidity();
  }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_VisaAndOshcDetails_Title);
    }else{
      this.titleService.setTitle(Tab_Title.VisaAndOshcDetails_Title);
    }
    this.visaohscFormGroup = this.formBuilder.group({
      isOnshoreWhileLodgingVisa: '',
      holdsAustralianVisa: '',
      visaSubclassId: '',
      visaExpiryDate: null,
      visaNumber: '',
      hasOshc: '',
      oshcProviderCode: '',
      oshcExpiryDate: null,
      isHealthCoverFromDEInternational: ''
    });


    this.visaSubClasses = this.activatedRoute.snapshot.data['visaSubClasses'];
    this.ohscProviders = this.activatedRoute.snapshot.data['ohscProviders'];


    this.applicationService.getVisaOhscDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.updateFormValuesFromVisaOhscDetails(response.Result);
          this.initialVisaOHSCDetails = this.getVisaOHSCDetails();
        }
      }, err => {
        console.error(err);
      });

    // this.configureJquery();

    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {

          this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

          if (this.isSubmittedApplication) {
            this.visaohscFormGroup.disable();
          }

        }
      }, err => {
        console.error(err);
      });

  }

  updateStudentLocation(isOnshoreWhileLodgingVisa: boolean) {

    this.isOnshoreWhileLodgingVisa = isOnshoreWhileLodgingVisa;

    this.visaohscFormGroup.patchValue({
      isOnshoreWhileLodgingVisa
    });

    this.visaohscFormGroup.updateValueAndValidity();

  }


  updateAustralianVisaStatus(holdsAustralianVisa: boolean) {
    this.holdsAustralianVisa = holdsAustralianVisa;

    this.visaohscFormGroup.patchValue({
      holdsAustralianVisa: holdsAustralianVisa
    });

    if (!holdsAustralianVisa) {
      this.visaohscFormGroup.patchValue({
        visaSubclassId: 0,
        visaExpiryDate: null,
        visaNumber: ''
      });
    }

    this.visaohscFormGroup.updateValueAndValidity();

    // this.configureJquery();

  }

  updateOhscStatus(hasOshc: boolean) {

    this.hasOshc = hasOshc;
    this.visaohscFormGroup.patchValue({
      hasOshc
    });

    if (!hasOshc) {
      this.visaohscFormGroup.patchValue({
        oshcProviderCode: '',
        oshcExpiryDate: null,
      });
    }

    this.visaohscFormGroup.updateValueAndValidity();

    this.updateHealthCoverFromDEInternational(!hasOshc);
    // this.configureJquery();

  }

  updateHealthCoverFromDEInternational(isHealthCoverFromDEInternational: boolean) {
    this.isHealthCoverFromDEInternational = isHealthCoverFromDEInternational;
    this.visaohscFormGroup.patchValue({
      isHealthCoverFromDEInternational
    });

    this.visaohscFormGroup.updateValueAndValidity();
  }

  isThisFieldHasErrors(fieldName: string): boolean {
    return this.isFormSubmitted && this.visaohscFormGroup.get(fieldName).errors != null;
  }

  isThisFieldHasApiError(fieldName: string): boolean {
    return this.isFormSubmitted
      && this.visaohscFormGroup.get(fieldName).errors != null
      && this.visaohscFormGroup.get(fieldName).errors.apiValidationError != null;
  }

  getDefaultOption(): LookupData {
    return {
      Code: '',
      Description: 'Please select',
    };
  }


  setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);

    if (errorField) {
      const { formFieldName } = errorField;
      this.visaohscFormGroup.get(formFieldName).setErrors({ apiValidationError: true });
      errorField.apiValidationErrorMsg = apiErrorMsg;
    }

  }

  getApiValidationErrorMsg(formFieldName: string): string {
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.formFieldName === formFieldName);
    return errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }


  getVisaOHSCDetails(): VisaOshc {
    const visaOhscDetails = new VisaOshc();

    visaOhscDetails.IsOnshoreWhileLodgingVisa = this.visaohscFormGroup.get('isOnshoreWhileLodgingVisa').value;
    visaOhscDetails.HoldsAustralianVisa = this.visaohscFormGroup.get('holdsAustralianVisa').value;

    if (visaOhscDetails.HoldsAustralianVisa) {

      visaOhscDetails.VisaSubclassId = this.visaohscFormGroup.get('visaSubclassId').value || null;

      if (visaOhscDetails.VisaSubclassId) {      
        const selectedVisa = this.visaSubClasses.find(vs => vs.VisaSubclassId == visaOhscDetails.VisaSubclassId);
  
        // these are used in fluent validation of the dto in the Web-Api layer (the Expiry Date is can't be in the past if the visa subclass is that of a bridging visa)
        visaOhscDetails.VisaSubclassCode = selectedVisa.Code;
        visaOhscDetails.VisaSubclassDescription = selectedVisa.Description;
      } else {
        visaOhscDetails.VisaSubclassCode = '';
        visaOhscDetails.VisaSubclassDescription = '';
      }
      
      visaOhscDetails.VisaExpiryDate = this.utilityService.getDateStrWithoutTimeZone(this.visaohscFormGroup.get('visaExpiryDate').value);
      visaOhscDetails.VisaNumber = this.visaohscFormGroup.get('visaNumber').value;

    } else {
      visaOhscDetails.VisaSubclassId = null;
      visaOhscDetails.VisaSubclassCode = '';
      visaOhscDetails.VisaSubclassDescription = '';
      visaOhscDetails.VisaExpiryDate = '';
      visaOhscDetails.VisaNumber = '';
    }

    visaOhscDetails.HasOshc = this.visaohscFormGroup.get('hasOshc').value;

    if (visaOhscDetails.HasOshc) {      
      visaOhscDetails.OshcProviderCode = this.visaohscFormGroup.get('oshcProviderCode').value;
      visaOhscDetails.OshcExpiryDate = this.utilityService.getDateStrWithoutTimeZone(this.visaohscFormGroup.get('oshcExpiryDate').value);
      
      visaOhscDetails.IsHealthCoverFromDEInternational = false;
    } else {
      visaOhscDetails.OshcProviderCode = '';
      visaOhscDetails.OshcExpiryDate =  '';
      visaOhscDetails.IsHealthCoverFromDEInternational = this.visaohscFormGroup.get('isHealthCoverFromDEInternational').value || false;
    }

    visaOhscDetails.IsReciprocalHealthCareCountry = this.isReciprocalHealthCareCountry;
    
    return visaOhscDetails;
  }

  getDate(fieldName: string): string {


    // const datePickerDate = $(`#${fieldName}`).datepicker('getDate');
    const dateObject = this.visaohscFormGroup.get(fieldName).value;

    const dateTimeObject = DateTime.fromJSDate(dateObject);

    if (!dateTimeObject.isValid) {
      return null;
    }

    const initialDate = new Date(1970, 0, 1);

    if (dateObject.getDate() === initialDate.getDate() &&
      dateObject.getMonth() === initialDate.getMonth() &&
      dateObject.getFullYear() === initialDate.getFullYear()) {
      return null;
    }

    const userTimezoneOffset = dateObject.getTimezoneOffset() * 60000;
    const date = new Date(dateObject.getTime() - userTimezoneOffset);

    return date.toISOString();
  }

  convertDateToString(dateInString: string): string {
    if (!dateInString) {
      return null;
    }

    const date = new Date(dateInString);
    const dateStr = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : '';
    return dateStr;
  }

  updateFormValuesFromVisaOhscDetails(visaOhscDetails: VisaOshc): void {
    this.visaohscFormGroup.patchValue({
      isOnshoreWhileLodgingVisa: visaOhscDetails.IsOnshoreWhileLodgingVisa,
      holdsAustralianVisa: visaOhscDetails.HoldsAustralianVisa,
      visaSubclassId: visaOhscDetails.VisaSubclassId || 0,
      visaExpiryDate: visaOhscDetails.VisaExpiryDate ? new Date(visaOhscDetails.VisaExpiryDate) : null,
      visaNumber: visaOhscDetails.VisaNumber ? visaOhscDetails.VisaNumber.trim() : '',
      hasOshc: visaOhscDetails.HasOshc,
      oshcProviderCode: visaOhscDetails.OshcProviderCode ? visaOhscDetails.OshcProviderCode : '',
      oshcExpiryDate: visaOhscDetails.OshcExpiryDate ? new Date(visaOhscDetails.OshcExpiryDate) : null,
      isHealthCoverFromDEInternational: visaOhscDetails.IsHealthCoverFromDEInternational,
      isReciprocalHealthCareCountry: visaOhscDetails.IsReciprocalHealthCareCountry
    });

    this.isOnshoreWhileLodgingVisa = visaOhscDetails.IsOnshoreWhileLodgingVisa;
    this.holdsAustralianVisa = visaOhscDetails.HoldsAustralianVisa;
    this.hasOshc = visaOhscDetails.HasOshc;
    this.isHealthCoverFromDEInternational = visaOhscDetails.IsHealthCoverFromDEInternational;
    this.isReciprocalHealthCareCountry = visaOhscDetails.IsReciprocalHealthCareCountry

    this.visaohscFormGroup.updateValueAndValidity();
    // this.configureJquery();

    this.visaSubclassUpdate();
  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isSaveSuccessful) {
      return true;
    }

    if (!this.isVisaOHSCDetailsSame()) {
      this.modalService.showModal();
      return this.modalService.stayOnThePage;
    } else {
      this.modalService.hideModal();
      return true;
    }
  }


  isVisaOHSCDetailsSame(): boolean {

    const currentVisaOhscDetails = this.getVisaOHSCDetails();
    const initialVisaOhscDetails = this.initialVisaOHSCDetails;

    const isVisaOHSCDetailsSame = compareVisaOHSCDetails(initialVisaOhscDetails, currentVisaOhscDetails);

    return isVisaOHSCDetailsSame;
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }

  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'accommodation-welfare']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'special-circumstances']);
  }

  resetErrors() {
    this.errorKeyFormFieldMapping.forEach(formField => formField.apiValidationErrorMsg = null);
  }

  saveAndContinue() {

    this.isFormSubmitted = true;
    const visaOhscDetails = this.getVisaOHSCDetails();
    this.applicationService.updateVisaOhscDetails(this.applicationId, visaOhscDetails)
      .subscribe((response: SingleResultApiResponse) => {
        this.dispatchSectionSaveAction();
        this.isSaveSuccessful = true;
        if (response.Result) {
          this.showChangeImpactModal = response.Result.IsVisaStatusChanged || response.Result.IsOshcStatusChanged;
        }
        if (this.showChangeImpactModal === false) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'special-circumstances']);
        } else {
          setTimeout(() => {
            this.resolve.nativeElement.focus();
          }, 100);
        }
      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        //console.log(errorResponse);
        for (const error of errors) {
          this.setApiValidationError(error.Key, error.Value);
        }
        this.visaohscFormGroup.updateValueAndValidity();
        // this.configureJquery();
        this.dispatchSectionSaveAction();
        this.initialVisaOHSCDetails = this.getVisaOHSCDetails();
        this.isScrollDone = false;
        this.formService.scrollToFirstErrorField();
      });
  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  visaSubclassUpdate() {
    const selectedVisa = this.visaSubClasses.find(visa => visa.VisaSubclassId == this.visaohscFormGroup.get('visaSubclassId').value);

    if (selectedVisa) {
      this.isBridgingVisa = this.bridgingVisas.some(bv => bv.Code === selectedVisa.Code);
    } else {
      this.isBridgingVisa = false;
    }

  }

  displayChangeImpactModal(): boolean {
    return this.showChangeImpactModal;
  }

  closeChangeImpactModal() {
    this.showChangeImpactModal = false;
    this.router.navigate(['/applications', this.applicationId, 'edit', 'special-circumstances']);
  }

  //accessibility -- link error msg to form field
  errorDoubleErrorAccessibility(formControlName: string, requireErrorId: string, apiErrorId: string): string {
    if (this.isFormSubmitted &&
      this.visaohscFormGroup.get(formControlName).errors &&
      this.visaohscFormGroup.get(formControlName).errors.required) {
      return requireErrorId;
    } else if (this.isFormSubmitted &&
      this.visaohscFormGroup.get(formControlName).errors &&
      this.visaohscFormGroup.get(formControlName).errors.apiValidationError) {
      return apiErrorId;
    } else {
      return "";
    }
  }
}
